/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pt_PeroranganInputs */

const en_cp_pt_perorangan = /** @type {(inputs: Cp_Pt_PeroranganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Individual student (voucher)`)
};

const id_cp_pt_perorangan = /** @type {(inputs: Cp_Pt_PeroranganInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahasiswa perorangan (voucher)`)
};

/**
* | output |
* | --- |
* | "Individual student (voucher)" |
*
* @param {Cp_Pt_PeroranganInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pt_perorangan = /** @type {((inputs?: Cp_Pt_PeroranganInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pt_PeroranganInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pt_perorangan(inputs)
	return en_cp_pt_perorangan(inputs)
});